import type { ExpiringCertRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: ExpiringCertRow[];
  onWorker: (id: string) => void;
}

export function ExpiringCertsSection({ rows, onWorker }: Props) {
  return (
    <CompSection title={`⚠ Expiring Within 30 Days (${rows.length})`} type="warn">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Worker</th>
              <th>Certificate</th>
              <th>Expires</th>
              <th>Days Left</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.workerId}-${r.certType}-${i}`}>
                <td style={{ cursor: 'pointer' }} onClick={() => onWorker(r.workerId)}>
                  {r.workerName}
                </td>
                <td>{r.certType}</td>
                <td>{r.expiry}</td>
                <td style={{ color: 'var(--warn)', fontWeight: 700 }}>{`${r.daysLeft}d`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="No certs expiring within 30 days" />
      )}
    </CompSection>
  );
}
